// extracted by mini-css-extract-plugin
module.exports = {"boxImage":"BoxCertificateImage_boxImage__1reuH","buttonDownload":"BoxCertificateImage_buttonDownload__1Q8qw","background_white":"BoxCertificateImage_background_white__2Ah8p"};